export default __webpack_public_path__ + "static/media/img_blog02.5d5c6758.jpg";